export default __webpack_public_path__ + "static/media/play-icon.eea6643d.svg";